<template lang="pug">
  #info
    p イベント開催期間: {{ beginTime.format('YYYY/MM/DD(ddd) HH:mm') }} ～ {{ endTime.format('YYYY/MM/DD(ddd) HH:mm') }}予想
    p
      div
        span(style='margin-right:10px') 目標総絵馬数: {{ requiredTotalEma }}
        span (目安: {{ emaPerDay }}個/日)
      div
        span(v-if='requiredDiffEma > 0') 目標達成まであと {{ requiredDiffEma }}個  
        b(v-else) 目標達成！！
    p
      div
        span(style='margin-right:10px') 今日の目標: 累計{{ quotaTotalEma }}個
        span (現在: 累計{{ obtainedTotalEma }}個)
      div
        span(v-if='quotaDiffEma > 0') ノルマ達成まであと{{ quotaDiffEma }}個
        b(v-else) 今日のノルマ達成！！
</template>

<script>
import moment from 'moment-timezone'
moment.locale('ja')
moment.tz.setDefault('Asia/Tokyo')

export default {
  data () {
    return {
      today: moment(),
      beginTime: moment('2017-10-27T16:00+0900'),
      endTime: moment('2017-11-09T10:00+0900')
    }
  },
  computed: {
    ema () {
      return this.$store.state.currentEma
    },
    appData () {
      return this.$store.getters.getAppData
    },
    wants () {
      return this.appData.filter(data => data.wants)
    },
    quotaTime () {
      return this.today.startOf('day').add(1, 'days')
    },
    eventHours () {
      return this.endTime.diff(this.beginTime, 'hours')
    },
    quotaPassedHours () {
      return this.quotaTime.diff(this.beginTime, 'hours')
    },
    requiredTotalEma () {
      return this.wants.map(data => data.rewards.ema * data.rewards.max)
        .reduce((prev, curr) => prev + curr, 0)
    },
    obtainedTotalEma () {
      return this.wants.map(data => data.rewards.ema * data.exchanged)
        .reduce((prev, curr) => prev + curr, 0) + this.ema
    },
    requiredDiffEma () {
      return this.requiredTotalEma - this.obtainedTotalEma
    },
    emaPerHour () {
      return this.requiredTotalEma / this.eventHours
    },
    emaPerDay () {
      return Math.ceil(this.emaPerHour * 24)
    },
    quotaTotalEma () {
      return Math.ceil(this.emaPerHour * this.quotaPassedHours)
    },
    quotaDiffEma () {
      return this.quotaTotalEma - this.obtainedTotalEma
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Info.vue